/**
 * Que mensagem de ALERTA ganha o cartão de proposta (consoleai#25071).
 *
 * O cartão nasce na resposta do @Atendente (`kind='bot'`). O aviso da retomada da
 * conta é `kind='alert'` e, quando abre o rascunho em branco, carrega o cartão do
 * formulário no `metadata.proposed_action` — antes ele mandava responder "abra o
 * formulário" e o cartão dependia de o modelo escolher a ferramenta certa (conversa
 * 851879, 27/10/2026: não escolheu).
 *
 * Só o do formulário: ele não confirma nada (abre o wizard, com os portões do
 * servidor) e é o único que o servidor põe num aviso. Alerta do motor carrega o
 * `source_meta` do evento no metadata, e um `proposed_action` vindo por ali não
 * vira botão.
 */
import type { ProposedAction } from './components/ActionProposalCard'

export const CARTAO_DO_FORMULARIO = 'abrir_formulario_de_ambiente'

export function cartaoDoAviso(kind: string, proposedAction: ProposedAction | null): boolean {
  return kind === 'alert' && proposedAction?.action_type === CARTAO_DO_FORMULARIO
}
